/*
 *
 * GiftCardProduct constants
 *
 */

export const DEFAULT_ACTION = '/GiftCardProduct/DEFAULT_ACTION';
export const FETCH_GIFTCARDDETAILS_SUCCESS = '/GiftCardProduct/FETCH_GIFTCARDDETAILS_SUCCESS';
const SET_GIFTCARD_CONTACT = '/GiftCardProduct/SET_GIFTCARD_CONTACT';

export const SHIPPING_TEXT = 'Shipping & Handling charges may or may not be applicable.';
export const MANIPAL_SHIPPING_TEXT = `<p>1. Shipping is standard<br>2. Min order:1 ; max: as per the requirement<br>
3. Max shipping days: 15<br>4. TAT: 7 to 10 days`;
export const MANDATORY_FIELDS = ['email', 'phone'];

export const GET_TAB_ACTIONTYPES = (event) => {
  let actionType = '';
  switch (event) {
    case 'how_to_redeem':
      actionType = 'Product - T&C';
      break;
    case 'description':
      actionType = 'Product - Description';
      break;
    case 'shipping_info':
      actionType = 'Product - Shipping';
      break;

    default:
      actionType = null;
  }
  return actionType;
};

// export const GETDELIVERY_TIME = () => 'Order will be fulfilled shortly';
//   if (productName === 'amazon-e-gift-voucher' || productName === 'flipkart-e-gift-voucher') {
//     return 'Order will be fulfilled shortly';
//   }
//   return delivery_value;
// };

const GIFTCARD_PRODUCT_VARIATIONS = (payload, value, id) => {
  let data = [];
  if (value || value === '') {
    data = payload.map((item, i) => ({
      ...item,
      value: (item.free_field && value) || item.value,
      active: (item.id === id) && true,
      key: i,
    }));
  } else {
    // here in this case 'id' comes as giftcardType
    data = payload.map((item, i) => ({
      ...item,
      value: item.free_field ? 0 : item.variation_types && item.variation_types.length && item.variation_types[0].value,
      active: id === 'merchandise' ? false : i === 0 && true,
      key: i,
      type: id,
    }));
  }
  return data;
};

export { SET_GIFTCARD_CONTACT, GIFTCARD_PRODUCT_VARIATIONS };



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/constants.js